import React from 'react';
import {
  Typography,
  Box,
  Paper,
  CircularProgress,
  Button,
  List,
  IconButton,
} from '@mui/material';
import { History as HistoryIcon, Refresh } from '@mui/icons-material';
import api from 'services/api';
import useAppStore from 'store/useAppStore';
import RenderHistoryItem from './RenderHistoryItem';
const HistoryArea = ({ seg_script_id, handleRestoreVersion }) => {
  const user_id = useAppStore((state) => state.user.id);
  const comp_name = useAppStore((state) => state.user.company);
  const project_id = useAppStore((state) => state.selectedProject.project_id);
  const {
    currentData,
    isFetching: isGetSegScriptListFetching,
    isError: isGetSegScriptListError,
    isUninitialized: isGetSegScriptListUninitialized,
    refetch: refetchHistory,
  } = api.endpoints.getSegScriptList.useQuery(
    {
      seg_script_id: seg_script_id,
      flag: '0',
      user_id: user_id,
      comp_name: comp_name,
      project_id: project_id,
    },
    { refetchOnMountOrArgChange: true },
  );
  if (isGetSegScriptListUninitialized) {
    return <div>尚未取得segScript</div>;
  }
  if (!currentData && isGetSegScriptListFetching) {
    return <CircularProgress />;
  }
  if (isGetSegScriptListError) {
    return (
      <div className="flex flex-col items-center p-2">
        取得資料發生錯誤
        <Button component="span" onClick={refetchHistory}>
          重試
        </Button>
      </div>
    );
  }
  return (
    <Paper className="flex min-w-0 flex-1 flex-col p-2" variant="outlined">
      <div className="flex items-center gap-1">
        <HistoryIcon color="primary" />
        <span className="font-bold">歷史紀錄</span>
        <IconButton
          className="ml-auto"
          onClick={refetchHistory}
          loading={isGetSegScriptListFetching}
        >
          <Refresh />
        </IconButton>
      </div>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {currentData.seg_script_list.length === 0 ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: 'center', mt: 4 }}
          >
            尚無歷史版本
          </Typography>
        ) : (
          <List>
            {currentData.seg_script_list.map((version, index) => (
              <RenderHistoryItem
                key={index}
                version={version}
                segScriptId={seg_script_id}
                handleRestoreVersion={handleRestoreVersion}
              />
            ))}
          </List>
        )}
      </Box>
    </Paper>
  );
};
export default HistoryArea;
